import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import SvgIcon from '@mui/material/SvgIcon'
import CircularProgress from '@mui/material/CircularProgress'

// A form, so the keyboard's return key submits it, with an arrow at the
// field's end for a phone, whose return key is a reach. inputProps carries
// the field's type and autofill: a phone's keyboard offers a texted code only
// to a field marked one-time-code.
const Input = ({
  value,
  onChange,
  onSubmit,
  submitLabel,
  belowText,
  adornment,
  isLoading,
  inputProps,
}) => (
  <Box
    component="form"
    noValidate
    onSubmit={(event) => {
      event.preventDefault()
      if (!isLoading) onSubmit()
    }}
    sx={{ position: 'relative' }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottomColor: 'text.primary',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        fontSize: '24px',
        lineHeight: '30px',
        pb: 1,
        '& input': {
          backgroundColor: 'transparent',
          outline: 0,
          border: 0,
          color: 'text.primary',
          width: 250,
          ml: 1,
          fontSize: '24px',
          pb: 0,
          lineHeight: '30px',
        },
      }}
    >
      <Box>{adornment}</Box>
      <input
        autoFocus
        value={value}
        onChange={(e) => onChange(e.target.value)}
        {...inputProps}
      />
      <IconButton
        type="submit"
        aria-label={submitLabel}
        disabled={isLoading || !value}
        sx={{ color: 'text.primary', p: 0.5 }}
      >
        <SvgIcon>
          <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
        </SvgIcon>
      </IconButton>
    </Box>
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        textAlign: 'center',
        top: 'calc(100% + 10px)',
        fontSize: '0.8em',
      }}
    >
      {isLoading ? (
        <CircularProgress size={20} sx={{ color: 'text.primary' }} />
      ) : (
        belowText
      )}
    </Box>
  </Box>
)

export default Input
